import React, { useState, useContext, useEffect, useMemo } from 'react'
import { M_InputTextField, M_CheckBox, M_DrawerTableTextField, LoadingContext, BufferService, M_StateActions, M_Header, M_Button, M_MessageBoard, NavigateContext } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import Observations from './componentsOrderService/observations'
import DigitalArchive from './componentsOrderService/digitalArchive'
import ShippingInformation from './componentsOrderService/shippingInformation'
import TransportationResources from './componentsOrderService/transportationResources'
import Container from './componentsOrderService/container'
import RORO from './componentsOrderService/RORO'
import Receiver from './componentsOrderService/receiver'
import ADR from './componentsOrderService/ADR'
import AddressList from './componentsOrderService/addressList'
import { useDispatch, useSelector } from 'react-redux'
import CreateOrderServiceInTabs from './createOrderServiceInTabs'
import axios from 'axios'
import './orderServices.css'

export default function CreateOrderService() {
    const dispatch = useDispatch()
    const M_State = useSelector((state) => state.StateKeyValue)
    // options
    const [optionsOrderService, setOptionsOrderService] = useState([])
    const [optionsTransportResources, setOptionsTransportResources] = useState([])
    const [optionsServiceContainer, setOptionsServiceContainer] = useState([])
    const [optionsRORO, setOptionsRORO] = useState([])
    const [optionsAddress, setOptionsAddress] = useState([])
    const [optionsShippingInformation, setOptionsShippingInformation] = useState([])
    const [optionsADR, setOptionsADR] = useState([])
    const [optionsReceiver, setOptionsReceiver] = useState([])
    const [optionsContainer, setOptionsContainer] = useState([])
    const [optionsDigitalArchiveCategory, setOptionsDigitalArchiveCategory] = useState([])
    const [optionsSubResource, setOptionsSubResource] = useState([])

    // maps
    const [orderService, setOrderService] = useState(new Map())
    const [transportResources, setTransportResources] = useState({})
    const [transportSubResources, setTransportSubResources] = useState({})
    const [container, setContainer] = useState({})
    const [ROROMap, setROROMap] = useState({})
    const [address, setAddress] = useState([])
    const [shippingInformation, setShippingInformation] = useState({})
    const [ADRMap, setADRMap] = useState([])
    const [newContainer, setNewContainer] = useState({})

    // variables
    const { t } = useTranslation()
    const ctx = useContext(LoadingContext)
    const ctx2 = useContext(NavigateContext)
    const colorStatus = 'grey'
    const status = 'Draft'
    const [isFirstLoop, setIsFirstLoop] = useState(true)
    const [id, setId] = useState(M_State.filter(obj => obj.key === 'selectedTab')[0]?.value)
    const [orderServiceId, setOrderServiceId] = useState('')
    const [operation, setOperation] = useState('')
    const [isTabsVisible, setIsTabsVisible] = useState(true)
    const [openModalGenerator, setOpenModalGenerator] = useState(false)
    const [modalAddContainer, setModalAddContainer] = useState(false)
    const [modalReturn, setModalReturn] = useState(false)
    const [modalViewAddress, setModalViewAddress] = useState(false)
    const [activeStep, setActiveStep] = useState(0)
    const [files, setFiles] = useState([])
    const serviceType = orderService.get("ServiceType")
    const reload = orderService.get("Reload") === true
    const full = orderService.get("Full") === true


    const bufferServiceOrderService = new BufferService('ServiceOrder')
    const bufferServiceTransportResource = new BufferService('TransportResource')
    const bufferServiceContainer = new BufferService('ServiceContainer')
    const bufferServiceAddress = new BufferService('ServiceOrderAddress')
    const bufferServiceShippingInformation = new BufferService('ExpeditionInfo')
    const bufferServiceRORO = new BufferService('RORO')
    const bufferServiceADR = new BufferService('ADRClassification')
    const bufferServiceContainers = new BufferService('Container')
    const bufferServiceCategory = new BufferService('DigitalArchiveCategory')
    const bufferServiceTransportSubResource = new BufferService('TransportSubResource')

    const sessionKeys = ['optionsOrderService', 'optionsTransportResources', 'optionsSubResource', 'optionsServiceContainer', 'optionsRORO', 'optionsAddress', 'optionsShippingInformation', 'optionsADR', 'optionsReceiver', 'optionsContainer', 'orderService', 'transportResources', 'container', 'ROROMap', 'address', 'shippingInformation', 'ADRMap', 'operation', 'isTabsVisible', 'activeStep', 'orderServiceId', 'files', 'optionsDigitalArchiveCategory', 'transportSubResources']

    useEffect(() => {
        if (isFirstLoop) {
            ctx.setIsLoad(true)
            getSessionStorageData(id)
            setIsFirstLoop(false)
        }
    }, [])

    // eslint-disable-next-line
    useEffect(() => {
        const newId = M_State.find(obj => obj.key === 'selectedTab')?.value
        if (newId && newId !== id) {
            setId(newId)
            getSessionStorageData(newId)
        }
    }, [id, M_State])

    useEffect(() => {
        const tempArray = sessionKeys.map((key) => sessionStorageMachine(id, key, key))
        dispatch(M_StateActions.addM_State({ key: id, value: tempArray }))
        // eslint-disable-next-line
    }, [id, optionsOrderService, optionsTransportResources, optionsSubResource, optionsServiceContainer, optionsRORO, optionsAddress, optionsShippingInformation, optionsADR, optionsReceiver, optionsContainer, orderService, transportResources, container, ROROMap, address, shippingInformation, ADRMap, operation, isTabsVisible, activeStep, orderServiceId, files, optionsDigitalArchiveCategory, transportSubResources])

    const sessionStorageMachine = (id, key, value) => {
        let tempObj = {}
        // eslint-disable-next-line
        if (eval(value) instanceof Map) {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (Array.from(eval(value))) }
        } else {
            // eslint-disable-next-line
            tempObj = { key: `${key}`, value: (eval(value)) }
        }
        return tempObj
    }

    const getSessionStorageData = (sessionID) => {
        ctx.setIsLoad(true)
        const M_StateData = M_State.filter(obj => obj.key === sessionID)[0]?.value
        if (M_StateData) {
            const tempOOS = M_StateData.filter(obj => obj.key === `optionsOrderService`)[0]?.value
            const tempOTR = M_StateData.filter(obj => obj.key === `optionsTransportResources`)[0]?.value
            const tempOSC = M_StateData.filter(obj => obj.key === `optionsServiceContainer`)[0]?.value
            const tempORO = M_StateData.filter(obj => obj.key === `optionsRORO`)[0]?.value
            const tempOAD = M_StateData.filter(obj => obj.key === `optionsAddress`)[0]?.value
            const tempOSI = M_StateData.filter(obj => obj.key === `optionsShippingInformation`)[0]?.value
            const tempOAR = M_StateData.filter(obj => obj.key === `optionsADR`)[0]?.value
            const tempOR = M_StateData.filter(obj => obj.key === `optionsReceiver`)[0]?.value
            const tempOC = M_StateData.filter(obj => obj.key === `optionsContainer`)[0]?.value
            const tempOS = M_StateData.filter(obj => obj.key === `orderService`)[0]?.value
            const tempTR = M_StateData.filter(obj => obj.key === `transportResources`)[0]?.value
            const tempCO = M_StateData.filter(obj => obj.key === `container`)[0]?.value
            const tempRM = M_StateData.filter(obj => obj.key === `ROROMap`)[0]?.value
            const tempAD = M_StateData.filter(obj => obj.key === `address`)[0]?.value
            const tempSI = M_StateData.filter(obj => obj.key === `shippingInformation`)[0]?.value
            const tempAM = M_StateData.filter(obj => obj.key === `ADRMap`)[0]?.value
            const tempOP = M_StateData.filter(obj => obj.key === `operation`)[0]?.value
            const tempTV = M_StateData.filter(obj => obj.key === `isTabsVisible`)[0]?.value
            const tempAS = M_StateData.filter(obj => obj.key === `activeStep`)[0]?.value
            const tempOI = M_StateData.filter(obj => obj.key === `orderServiceId`)[0]?.value
            const tempFI = M_StateData.filter(obj => obj.key === `files`)[0]?.value
            const tempDAC = M_StateData.filter(obj => obj.key === `optionsDigitalArchiveCategory`)[0]?.value
            const tempSR = M_StateData.filter(obj => obj.key === `optionsSubResource`)[0]?.value
            const tempTSR = M_StateData.filter(obj => obj.key === `transportSubResources`)[0]?.value
            if (tempOOS || tempOTR || tempOSC || tempORO || tempOAD || tempOSI || tempOAR || tempOR || tempOC || tempOR || tempOS || tempTR || tempCO || tempRM || tempAD || tempAM || tempOP || tempTV || tempAS || tempOI || tempFI || tempDAC || tempSR || tempTSR) {
                setOptionsOrderService(tempOOS)
                setOptionsTransportResources(tempOTR)
                setOptionsServiceContainer(tempOSC)
                setOptionsRORO(tempORO)
                setOptionsAddress(tempOAD)
                setOptionsShippingInformation(tempOSI)
                setOptionsADR(tempOAR)
                setOptionsReceiver(tempOR)
                setOptionsContainer(tempOC)
                setOrderService(new Map(tempOS))
                setTransportResources(tempTR)
                setContainer(tempCO)
                setROROMap(tempRM)
                setAddress(tempAD)
                setShippingInformation(tempSI)
                setADRMap(tempAM)
                setOperation(tempOP)
                setIsTabsVisible(tempTV)
                setActiveStep(tempAS)
                setOrderServiceId(tempOI)
                setFiles(tempFI)
                setOptionsDigitalArchiveCategory(tempDAC)
                setOptionsSubResource(tempSR)
                setTransportSubResources(tempTSR)
                ctx.setIsLoad(false)
                return
            }
        }
        ctx.setIsLoad(false)
        getOrderService()
    }

    const getOrderService = async () => {
        const getOperation = ctx.passValue.get('operation')
        const lines = ctx.passValue?.get('lines') || ""
        const getId = lines.Id || lines.ServiceOrderId
        ctx.passValue.delete('operation')
        ctx.passValue.delete('lines')
        ctx.setPassValue(new Map(ctx.passValue))

        setOperation(getOperation || 'create')
        setOrderServiceId(getId)
        ctx.setIsLoad(true)

        try {
            const promises = [
                bufferServiceOrderService.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsOrderService(response)
                    setOptionsReceiver(response
                        .filter(opt => opt.GroupByInfo === 'Recetor' && opt.Type === 'boolean')
                        .map(opt => ({ value: opt.Name, label: opt.NormalizedName }))
                    )
                }),
                bufferServiceTransportResource.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsTransportResources(response)
                }),
                bufferServiceContainer.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsServiceContainer(response)
                }),
                bufferServiceAddress.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsAddress(response)
                }),
                bufferServiceShippingInformation.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsShippingInformation(response)
                }),
                bufferServiceRORO.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsRORO(response)
                }),
                bufferServiceContainers.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsContainer(response)
                }),
                bufferServiceADR.options().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsADR(response.filter(opt => opt.IsHiddenList !== true))
                }),
                bufferServiceTransportSubResource.get().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsSubResource(response.Items)
                }),
                bufferServiceCategory.get().then(response => {
                    if (response.name === 'AxiosError') throw response
                    setOptionsDigitalArchiveCategory(response.Items)
                })
            ]

            if (getOperation === 'edit' || getOperation === 'copy') {
                promises.push(
                    bufferServiceOrderService.getId(getId).then(response => {
                        if (response.name === 'AxiosError') throw response
                        const orderServiceMap = new Map(Object.entries(response))

                        if (getOperation === 'copy') {
                            [
                                'Id',
                                'ServiceOrderId',
                                'ServiceContainerId',
                                'ExpeditionInfoId',
                                'ServiceOrderState',
                                'StateColor',
                                'CreatedBy',
                                'CreatedDate',
                                'UpdatedBy',
                                'UpdatedDate',
                                'TransportResourceResponse',
                                'ServiceContainerResponse',
                                'ExpeditionInfoResponse',
                                'ADRInformation',
                                'Address',
                                'DigitalArchives'
                            ].forEach((key) => orderServiceMap.delete(key))
                        }

                        setOrderService(orderServiceMap)
                        const tr = response.TransportResourceResponse;

                        // converter array → object map
                        const subResourcesMap = {};

                        tr?.TransportSubResources?.forEach(sr => {
                            subResourcesMap[sr.TransportSubResource] = true;
                        });

                        setTransportResources({
                            ...tr
                        });
                        setTransportSubResources(subResourcesMap);
                        if (response.RORO === true) {
                            setROROMap(response.ROROInformation)
                        } else {
                            setContainer(
                                getOperation === 'copy'
                                    ? sanitizeServiceContainerForCreate(response.ServiceContainerResponse)
                                    : response.ServiceContainerResponse
                            )
                        }
                        setAddress(
                            getOperation === 'copy'
                                ? (response.Address || []).map((addr) => ({
                                    ...addr,
                                    Id: generateUUID(),
                                    ServiceOrderAddressId: 0,
                                    ServiceOrderId: 0
                                }))
                                : response.Address
                        )
                        setShippingInformation(
                            getOperation === 'copy'
                                ? sanitizeExpeditionInfoForCreate(response.ExpeditionInfoResponse)
                                : response.ExpeditionInfoResponse
                        )
                        if (response.TransportResourceResponse.ADR) {
                            setADRMap(response.ADRInformation)
                        }
                        setFiles(getOperation === 'copy' ? [] : response.DigitalArchives)
                        console.log("response", response)
                    })
                )
            }
            await Promise.all(promises) // Aguarda todas as chamadas
        } catch (err) {
            if (err.name === 'AxiosError') {
                ctx.toastMessages('error', err.response?.data?.Errors?.[0] || 'Erro na API', '')
            } else {
                console.error(err)
            }
        } finally {
            ctx.setIsLoad(false) // Desativa o loading após tudo terminar
        }
    }

    const generateNextLocalId = (array) => {
        const localIds = array.map(obj => obj.LocalId).filter(id => typeof id === 'number')
        return localIds.length ? Math.max(...localIds) + 1 : 0
    }

    useEffect(() => {
        if (operation === 'edit' || optionsAddress.length === 0) return

        setAddress((prevAddresses) => {
            const nextAddresses = normalizeAddressesByRules(prevAddresses, serviceType, reload, full)
            if (JSON.stringify(prevAddresses) === JSON.stringify(nextAddresses)) return prevAddresses
            return nextAddresses
        })
    }, [operation, optionsAddress, serviceType, reload, full])


    const getFilteredAddressType = (serviceTypeValue, reloadValue, fullValue) => {
        const addressType = ['Pickup', 'Charge/Discharge', 'Delivery']

        return addressType.filter((type) => {
            return !(
                (type === 'Delivery' && serviceTypeValue === 'Importação' && reloadValue === true) ||
                (type === 'Pickup' && serviceTypeValue === 'Exportação' && reloadValue === true) ||
                (type === 'Pickup' && serviceTypeValue === 'Exportação' && fullValue === true)
            )
        })
    }

    const createAddressTemplate = (addressType, idValue) => {
        const options = optionsAddress.find(value => value.AddressType === addressType) || {}
        return {
            ...options,
            Id: idValue ?? generateUUID(),
            AddressType: addressType
        }
    }

    const normalizeAddressesByRules = (currentAddresses, serviceTypeValue, reloadValue, fullValue) => {
        const filteredAddressType = getFilteredAddressType(serviceTypeValue, reloadValue, fullValue)
        const allowedTypes = new Set(filteredAddressType)
        const existingAllowed = currentAddresses.filter(addr => allowedTypes.has(addr.AddressType))

        const pickup = existingAllowed.find(addr => addr.AddressType === 'Pickup')
        const delivery = existingAllowed.find(addr => addr.AddressType === 'Delivery')
        const chargeDischarge = existingAllowed.filter(addr => addr.AddressType === 'Charge/Discharge')

        const orderedAddresses = []

        if (allowedTypes.has('Pickup')) {
            orderedAddresses.push(pickup || createAddressTemplate('Pickup'))
        }

        if (allowedTypes.has('Charge/Discharge')) {
            if (chargeDischarge.length > 0) {
                orderedAddresses.push(...chargeDischarge)
            } else {
                orderedAddresses.push(createAddressTemplate('Charge/Discharge'))
            }
        }

        if (allowedTypes.has('Delivery')) {
            orderedAddresses.push(delivery || createAddressTemplate('Delivery'))
        }

        return orderedAddresses
    }

    function createAddresses(serviceTypeParam, reloadParam, fullParam) {
        const currentServiceType = serviceTypeParam ?? serviceType
        const currentReload = reloadParam ?? reload
        const currentFull = fullParam ?? full
        const filteredAddressType = getFilteredAddressType(currentServiceType, currentReload, currentFull)

        const listAddresses = filteredAddressType.map((AddressType, index) => {
            return createAddressTemplate(AddressType, index)
        })

        setAddress(listAddresses)
    }

    const generateUUID = () => {
        const browserCrypto = typeof window !== 'undefined' ? window.crypto : undefined
        if (browserCrypto && typeof browserCrypto.randomUUID === 'function') {
            return browserCrypto.randomUUID()
        }

        if (browserCrypto && typeof browserCrypto.getRandomValues === 'function') {
            const bytes = browserCrypto.getRandomValues(new Uint8Array(16))
            bytes[6] = (bytes[6] & 0x0f) | 0x40
            bytes[8] = (bytes[8] & 0x3f) | 0x80
            const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0'))
            return `${hex.slice(0, 4).join('')}-${hex.slice(4, 6).join('')}-${hex.slice(6, 8).join('')}-${hex.slice(8, 10).join('')}-${hex.slice(10, 16).join('')}`
        }

        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
            const r = (Math.random() * 16) | 0
            const v = c === 'x' ? r : (r & 0x3) | 0x8
            return v.toString(16)
        })
    }

    const sanitizeServiceContainerForCreate = (serviceContainer = {}) => {
        if (!serviceContainer || typeof serviceContainer !== 'object') return {}

        const sanitizedContainer = { ...serviceContainer }

            ;['Id', 'ServiceContainerId', 'ServiceOrderId', 'CreatedBy', 'CreatedDate', 'UpdatedBy', 'UpdatedDate']
                .forEach((key) => delete sanitizedContainer[key])

        return sanitizedContainer
    }

    const sanitizeExpeditionInfoForCreate = (expeditionInfo = {}) => {
        if (!expeditionInfo || typeof expeditionInfo !== 'object') return {}

        const sanitizedExpeditionInfo = { ...expeditionInfo }

            ;['Id', 'ExpeditionInfoId', 'ServiceOrderId', 'CreatedBy', 'CreatedDate', 'UpdatedBy', 'UpdatedDate']
                .forEach((key) => delete sanitizedExpeditionInfo[key])

        return sanitizedExpeditionInfo
    }


    const addAddress = () => {
        const deliveryIndex = address.findIndex(addr => addr.AddressType === 'Delivery')
        const newLocalId = generateNextLocalId(address)

        const newAddress = {
            Id: generateUUID(),
            LocalId: newLocalId,
            AddressType: 'Charge/Discharge',
        }

        const newAddressList = [
            ...address.slice(0, deliveryIndex),
            newAddress,
            ...address.slice(deliveryIndex)
        ]

        setAddress(newAddressList)
        ctx.toastMessages('success', '', t("AddAddressSuccess"))
    }

    const deleteAddress = (index) => {
        const chargeDischargeAddresses = address.filter(addr => addr.AddressType === 'Charge/Discharge')
        const addressToDelete = address.find(addr => addr.Id === index)

        if (chargeDischargeAddresses.length > 1 || (addressToDelete && addressToDelete.AddressType !== 'Charge/Discharge')) {
            setAddress(addresses => addresses.filter(addr => addr.Id !== index))
            ctx.toastMessages('success', '', t("DeleteLine"))
        } else {
            ctx.toastMessages('error', '', t("ErrorDeletingLine"))
        }
    }

    const createStructureAddress = (updates, index) => {
        const getname = Object.keys(updates)[0]
        const currentAddress = address.find(addr => addr.Id === index)
        const currentAddressCode = currentAddress?.AddressCode

        if (
            (getname === 'AddressStreet' || getname === 'AddressPlace' || getname === 'AddressZipCode' || getname === 'AddressZipPlace' || getname === 'AddressCountryCode') &&
            (currentAddressCode === "" || currentAddressCode === null || currentAddressCode === undefined)
        ) {
            const generateURL = `${updates.AddressStreet || currentAddress.AddressStreet} ${currentAddress.AddressPlace} ${currentAddress.AddressZipCode} ${currentAddress.AddressZipPlace} ${currentAddress.AddressCountryCode}`

            axios.get(`https://api.mapbox.com/geocoding/v5/mapbox.places/${encodeURIComponent(generateURL)}.json?access_token=pk.eyJ1Ijoiam9hb21hcmFjbyIsImEiOiJjbTRrMzFyYzQwODBtMm1zMWg1emp2cDE4In0.ZKCrjBBIPyf9k1DU-uyqSQ`)
                .then((response) => {
                    const temArrayCoordinates = response.data.features[0]?.geometry?.coordinates
                    console.log("temArrayCoordinates", temArrayCoordinates)
                    if (temArrayCoordinates) {
                        const [longitude, latitude] = temArrayCoordinates
                        setAddress((prevAddresses) =>
                            prevAddresses.map((address) =>
                                address.Id === index
                                    ? {
                                        ...address,
                                        Latitude: latitude,
                                        Longitude: longitude,
                                    }
                                    : address
                            )
                        )
                    }
                })
        }

        setAddress((prevAddresses) =>
            prevAddresses.map((address) =>
                address.Id === index ? { ...address, ...updates } : address
            )
        )
    }



    const validateReceiver = (selectedValue) => {
        if (selectedValue === 'Other') {
            orderService.set('SelectedReceiver', selectedValue)
        } else {
            orderService.set('SelectedReceiver', selectedValue)
        }
        setOrderService(new Map(orderService))
    }

    const createStructure = (event, index, type) => {
        let updatedStructure =
            type === "Resources"
                ? { ...transportResources }
                : type === "SubResources"
                    ? { ...transportSubResources }
                    : type === "Container"
                        ? { ...container }
                        : type === "RORO"
                            ? { ...ROROMap }
                            : type === 'ShippingInformation'
                                ? { ...shippingInformation }
                                : "{ ...shippingInformation }"

        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            updatedStructure[index] = dateValue
        } else {
            updatedStructure[index] = typeof event === "boolean" ? event : isNaN(event) ? event : Number(event)
        }

        if (type === "Resources") {
            setTransportResources(updatedStructure)
        } else if (type === "SubResources") {
            setTransportSubResources(updatedStructure)
        } else if (type === 'Container') {
            console.log(index, event, type)
            setContainer(updatedStructure)
        } else if (type === 'RORO') {
            setROROMap(updatedStructure)
        } else if (type === 'ShippingInformation') {
            setShippingInformation(updatedStructure)
        }
    }

    const createStructureNewContainer = (value, index) => {
        setNewContainer(prevContainer => {
            return { ...prevContainer, [index]: value }
        })
    }

    function createNewContainer() {
        bufferServiceContainers.post(newContainer).then((response) => {
            if (response.name === "AxiosError") {
                ctx.toastMessages("error", '', response.message)
                return
            }
            ctx.toastMessages("success", '', t("Success"))
            setModalAddContainer(false)
        })
    }

    const addOrderService = (event, index) => {
        const updatedOrderService = new Map(orderService)
        if (event.type === "date") {
            const dateValue = new Date(event).toISOString().split("T")[0]
            updatedOrderService.set(index, dateValue)
        } else {
            updatedOrderService.set(index, event)
        }
        setOrderService(updatedOrderService)
    }

    const submitOrderService = () => {

        const subResourcesArray =
            optionsSubResource
                .filter(elem => transportSubResources[elem.Name])
                .map(elem => {
                    const existingSubResource = transportResources?.TransportSubResources?.find(
                        (sr) => sr.TransportSubResourceId === elem.TransportSubResourceId
                    )

                    return {
                        TransportResourceId: transportResources.TransportResourceId,
                        TransportSubResourceId: elem.TransportSubResourceId,
                        TransportResourceSubResourceId: operation === 'edit' ? (existingSubResource?.TransportResourceSubResourceId ?? 0) : 0
                    }
                })

        orderService.set("ServiceOrderStateId", 1)
        const transportResourcePayload = { ...(transportResources || {}) }
        delete transportResourcePayload.transportSubResources

        const transportResourceRequest = {
            ...transportResourcePayload,
            TransportSubResources: subResourcesArray
        }
        orderService.set("TransportResourceRequest", transportResourceRequest)
        orderService.set("Address", address)
        orderService.set(
            "ExpeditionInfoRequest",
            operation === 'copy' ? sanitizeExpeditionInfoForCreate(shippingInformation) : shippingInformation
        )
        orderService.set("DigitalArchives", files)

        //validação campos order service
        const requiredFieldsOrderService = optionsOrderService.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsOrderService) {
            if (!orderService.has(field.Name) || !orderService.get(field.Name)) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }

        if (orderService.get('SelectedReceiver') === 'Other' && orderService.get('Shipper') === null) {
            ctx.toastMessages('error', 'Shipper', t("RequiredField"))
            return
        } else {
            orderService.delete('Shipper')
            orderService.delete('AddressId')
        }

        // validação campos RORO e campos container
        if (orderService.get('RORO') === true) {
            const requiredFieldsOptionsRORO = optionsRORO.filter((elem) => elem.IsRequired)
            for (const field of requiredFieldsOptionsRORO) {
                if (!ROROMap[field.Name] || !ROROMap[field.Name]) {
                    ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                    return
                }
            }
            orderService.set("ROROInformation", ROROMap)
            orderService.delete('ServiceContainerRequest')
        } else {
            const requiredFieldsContainer = optionsServiceContainer.filter((elem) => elem.IsRequired)
            for (const field of requiredFieldsContainer) {
                if (container.TemperatureControl === true && !("Temperature" in container)) {
                    ctx.toastMessages('error', 'Temperatura', t("RequiredField"))
                    return
                }

                if (container.SpecialDimensions === true && (!("Length" in container) || container.Length === 0)) {
                    ctx.toastMessages('error', t("Length"), t("RequiredField"))
                    return
                }

                if (container.SpecialDimensions === true && (!("Width" in container) || container.Width === 0)) {
                    ctx.toastMessages('error', t("Width"), t("RequiredField"))
                    return
                }

                if (container.SpecialDimensions === true && (!("Height" in container) || container.Height === 0)) {
                    ctx.toastMessages('error', t("Height"), t("RequiredField"))
                    return
                }

                if (!container[field.Name] || !container[field.Name]) {
                    ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                    return
                }
            }
            orderService.set(
                "ServiceContainerRequest",
                operation === 'copy' ? sanitizeServiceContainerForCreate(container) : container
            )
            orderService.delete('ROROInformation')
        }

        // validação campos address
        const requiredFieldsAddresses = optionsAddress.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsAddresses) {
            for (const addr of address) {
                if (addr.AddressType === 'Charge/Discharge' && field.Type === 'datetime') {
                    continue
                }
                if (!addr[field.Name] || !addr[field.Name].trim()) {
                    ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                    return
                }
            }
        }

        // validação dos campos adr se existir
        if (transportResources.ADR === true) {
            const requiredFieldsADR = optionsADR.filter((elem) => elem.IsRequired)
            for (const field of requiredFieldsADR) {
                for (const adr of ADRMap) {
                    if (!adr[field.Name] || !adr[field.Name].trim()) {
                        ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                        return
                    }
                }
            }
            orderService.set("ADRInformation", ADRMap)
        } else {
            orderService.delete('ADRInformation')
        }

        // validação campos informação do navio
        const requiredFieldsShippingInformation = optionsShippingInformation.filter((elem) => elem.IsRequired)
        for (const field of requiredFieldsShippingInformation) {
            if (!shippingInformation[field.Name] || !shippingInformation[field.Name]) {
                ctx.toastMessages('error', field.NormalizedName, t("RequiredField"))
                return
            }
        }

        ctx.setIsLoad(true)
        const payload = Object.fromEntries(orderService)

        // remover objetos apenas de visualização
        delete payload.ServiceContainerResponse
        delete payload.TransportResourceResponse
        delete payload.ExpeditionInfoResponse

        console.log("payload", payload)

        if (operation === 'create' || operation === 'copy') {
            bufferServiceOrderService.post(payload).then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages('error', response.response.data.Errors[0], '')
                    ctx.setIsLoad(false)
                    return
                }

                ctx.toastMessages("success", '', t("SuccessCreateQuote"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        } else {
            bufferServiceOrderService.update(orderServiceId, payload).then((response) => {
                if (response.name === "AxiosError") {
                    ctx.toastMessages('error', response.response.data.Errors[0], '')
                    ctx.setIsLoad(false)
                    return
                }

                ctx.toastMessages("success", '', t("Success"))
                ctx2.closeTab(id)
                ctx.setIsLoad(false)
            })
        }
    }

    const renderTransportationResources = useMemo(() => {
        return transportResources ? <TransportationResources optionsTransportResources={optionsTransportResources} transportResources={transportResources} setTransportResources={setTransportResources} createStructure={createStructure} t={t} container={container} /> : null
    }, [optionsTransportResources, transportResources, container])

    const addADR = () => {
        setADRMap(prev => [...prev, { Id: generateUUID() }])
    }


    const renderADR = useMemo(() => {
        return ADRMap ?
            <div className='cardOrderService'>
                <div className='divTitleCard'>
                    <div className='divAlignTitleStatus'>
                        <div className='iconTitleCard'>
                            <img src="/icons/svgsDaNet/radioactive.svg"
                                style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                alt="ADR"
                            />
                        </div>
                        <div className='labelTitleCard'>
                            ADR
                        </div>
                    </div>
                    <div className='divLabelStatus'>
                        <M_Button
                            label={t("AddADR")}
                            icon={<img src="/icons/svgsDaNet/add-circle.svg"
                                style={{ filter: 'invert(42%) sepia(44%) saturate(4434%) hue-rotate(74deg) brightness(97%) contrast(101%)', width: '24px' }}
                                alt="save" />
                            }
                            borderColor={'var(--color-grey)'}
                            onClick={addADR}
                        />
                    </div>
                </div>
                <ADR optionsADR={optionsADR} ADRMap={ADRMap} setADRMap={setADRMap} t={t} ctx={ctx} operation={operation} addADR={addADR} />
            </div> : null
    }, [optionsADR, ADRMap, operation])

    const renderContainer = useMemo(() => {
        return container ? <Container
            optionsServiceContainer={optionsServiceContainer}
            container={container}
            setContainer={setContainer}
            createStructure={createStructure}
            t={t}
            setOpenModalGenerator={setOpenModalGenerator}
            openModalGenerator={openModalGenerator}
            transportResources={transportResources}
            setTransportResources={setTransportResources}
        /> : null
    }, [optionsServiceContainer, container, openModalGenerator, transportResources])

    const renderRORO = useMemo(() => {
        return ROROMap ? <RORO optionsRORO={optionsRORO} ROROMap={ROROMap} createStructure={createStructure} t={t} /> : null
    }, [optionsRORO, ROROMap])

    const renderReceiver = useMemo(() => {
        return orderService ? <Receiver
            orderService={orderService}
            optionsOrderService={optionsOrderService}
            optionsReceiver={optionsReceiver}
            setOrderService={setOrderService}
            validateReceiver={validateReceiver}
            t={t}
        /> : null
    }, [orderService, optionsOrderService, optionsReceiver])

    const renderShippingInfo = useMemo(() => {
        return shippingInformation ? <ShippingInformation
            optionsShippingInformation={optionsShippingInformation}
            shippingInformation={shippingInformation}
            setShippingInformation={setShippingInformation}
            createStructure={createStructure} t={t}
        /> : null
    }, [optionsShippingInformation, shippingInformation])

    const renderObservations = useMemo(() => {
        return orderService ? <Observations orderService={orderService} optionsOrderService={optionsOrderService} addOrderService={addOrderService} t={t} /> : null
    }, [orderService, optionsOrderService])


    return (
        <>
            <M_Header
                element={
                    <>
                        <M_Button
                            tooltip={t("Back")}
                            icon={<i className="pi pi-arrow-left iconTable"></i>}
                            label={<b>{t("Back")}</b>}
                            onClick={() => setModalReturn(true)}
                        />
                        <M_Button
                            tooltip={t("Save")}
                            icon={<i className="pi pi-save iconTable"></i>}
                            label={<b>{t("Save")}</b>}
                            onClick={() => submitOrderService()}
                        />
                        {/* <M_Button
                            tooltip={"Change View"}
                            label={<b>{"Change View"}</b>}
                            onClick={() => setIsTabsVisible(prev => !prev)}
                            icon={
                                <img src="/icons/svgsDaNet/switch-horizontal.svg"
                                    style={{ filter: 'invert(0%) sepia(100%) saturate(0%) hue-rotate(334deg) brightness(102%) contrast(102%)', width: '17px', marginLeft: '10px' }}
                                    alt="OrderService"
                                />
                            }
                        /> */}
                    </>
                }
            />

            {!isTabsVisible ?
                <div className='divGlobalCreateOrderService'>
                    {/* card Order service */}
                    <div className='cardOrderService'>
                        <div className='divTitleCard'>
                            <div className='divAlignTitleStatus'>
                                <div className='iconTitleCard'>
                                    <img src="/icons/svgsDaNet/truck.svg"
                                        style={{ filter: 'invert(16%) sepia(66%) saturate(5073%) hue-rotate(347deg) brightness(74%) contrast(116%)' }}
                                        alt="OrderService"
                                    />
                                </div>
                                <div className='labelTitleCard'>
                                    {t("OrderService")}
                                </div>
                            </div>
                            <div className='divLabelStatus'>
                                <b>{t("Status")}:</b>
                                <div className='divBodyStatus' style={{ backgroundColor: colorStatus }}>
                                    {status}
                                </div>
                            </div>
                        </div>
                        <div className='divGridOrderService'>
                            {optionsOrderService
                                .filter((elem) => elem.IsHiddenList !== true && elem.GroupByInfo === "")
                                .map((elem, key) =>
                                    elem.IsForeignKey ? (
                                        <M_DrawerTableTextField
                                            key={key}
                                            tableLabel={elem.NormalizedName}
                                            label={elem.NormalizedName}
                                            required={elem.IsRequired}
                                            entity={elem.ForeignTableName}
                                            value={orderService.get(elem.ForeignTableToPassId) ?
                                                {
                                                    [elem.ForeignTableToPassId]: orderService.get(elem.ForeignTableToPassId),
                                                    [elem.ForeignKeyName]: orderService.get(elem.Name)
                                                } : null}
                                            filterField={elem.ForeignKeyName}
                                            labelFields={[elem.ForeignKeyName]}
                                            onSubmitValue={obj => {
                                                if (obj) {
                                                    orderService.set(elem.Name, obj[elem.ForeignKeyName])
                                                    orderService.set(elem.ForeignTableToPassId, obj[elem.ForeignTableToPassId])
                                                } else {
                                                    orderService.set(elem.Name, null)
                                                    orderService.set(elem.ForeignTableToPassId, null)
                                                }
                                                setOrderService(new Map(orderService))
                                            }}
                                            disabled={elem.disable}
                                            valueField={elem.ForeignTableToPassId}
                                        />
                                    ) : elem.Type === 'string' ? (
                                        <M_InputTextField
                                            key={key}
                                            type={"text"}
                                            label={elem.NormalizedName}
                                            onChange={(e) => addOrderService(e.target.value, elem.Name)}
                                            required={elem.IsRequired}
                                            value={orderService.get(elem.Name) || ""}
                                        />
                                    ) : elem.Type === 'boolean' ? (
                                        <div className='divCheckboxFormQuotes' key={key}>
                                            <M_CheckBox
                                                label={elem.NormalizedName}
                                                onChange={(e) => addOrderService(e.target.checked, elem.Name)}
                                                checked={orderService.get(elem.Name) || false}
                                                required={elem.IsRequired}
                                                noPadding
                                            />
                                        </div>
                                    ) : elem.Type === "datetime" ? (
                                        <M_InputTextField
                                            key={key}
                                            type={"datetime-local"}
                                            label={elem.NormalizedName}
                                            onChange={(e) => addOrderService(e.target.value, elem.Name)}
                                            required={elem.IsRequired}
                                            value={orderService.get(elem.Name) || ""}
                                        />
                                    ) : null
                                )
                            }
                        </div>
                    </div>

                    {/* card transport Resources */}
                    {renderTransportationResources}

                    {/* card informação ADR */}
                    {transportResources?.ADR && (
                        renderADR
                    )}

                    {/* card do formulário do Container */}
                    {!orderService?.get('RORO') && (
                        renderContainer
                    )}

                    {/* card do formulário do RORO */}
                    {orderService?.get('RORO') && (
                        renderRORO
                    )}

                    {/* card de formulário das moradas */}
                    <AddressList optionsAddress={optionsAddress} address={address} setAddress={setAddress} addAddress={addAddress} deleteAddress={deleteAddress} createStructureAddress={createStructureAddress} orderService={orderService} t={t} />

                    {/* div com card tripla */}
                    <div className='divgrid3Columns'>

                        {/* card do receiver */}
                        {renderReceiver}

                        {/* card do Shipping Information */}
                        {renderShippingInfo}

                        {/* card das Observações */}
                        {renderObservations}
                    </div>

                    {/* div card do upload de ficheiros */}
                    <DigitalArchive />
                </div>
                :
                <CreateOrderServiceInTabs
                    optionsOrderService={optionsOrderService}
                    optionsTransportResources={optionsTransportResources}
                    optionsADR={optionsADR}
                    optionsServiceContainer={optionsServiceContainer}
                    optionsRORO={optionsRORO}
                    optionsAddress={optionsAddress}
                    optionsShippingInformation={optionsShippingInformation}
                    optionsReceiver={optionsReceiver}
                    orderService={orderService}
                    setOrderService={setOrderService}
                    addOrderService={addOrderService}
                    transportResources={transportResources}
                    setTransportResources={setTransportResources}
                    ADRMap={ADRMap}
                    setADRMap={setADRMap}
                    addADR={addADR}
                    container={container}
                    setContainer={setContainer}
                    ROROMap={ROROMap}
                    address={address}
                    addAddress={addAddress}
                    deleteAddress={deleteAddress}
                    createStructureAddress={createStructureAddress}
                    validateReceiver={validateReceiver}
                    shippingInformation={shippingInformation}
                    setShippingInformation={setShippingInformation}
                    createStructure={createStructure}
                    setOpenModalGenerator={setOpenModalGenerator}
                    setModalAddContainer={setModalAddContainer}
                    operation={operation}
                    activeStep={activeStep}
                    setActiveStep={setActiveStep}
                    bufferServiceContainers={bufferServiceContainers}
                    createAddresses={createAddresses}
                    createStructureNewContainer={createStructureNewContainer}
                    newContainer={newContainer}
                    setNewContainer={setNewContainer}
                    modalAddContainer={modalAddContainer}
                    createNewContainer={createNewContainer}
                    optionsContainer={optionsContainer}
                    files={files}
                    setFiles={setFiles}
                    optionsDigitalArchiveCategory={optionsDigitalArchiveCategory}
                    setOptionsDigitalArchiveCategory={setOptionsDigitalArchiveCategory}
                    modalViewAddress={modalViewAddress}
                    setModalViewAddress={setModalViewAddress}
                    optionsSubResource={optionsSubResource}
                    transportSubResources={transportSubResources}
                    ctx={ctx}
                />
            }

            {/* alerta de gerador no contentor */}
            <M_MessageBoard
                open={openModalGenerator}
                onClose={() => setOpenModalGenerator(false)}
                title={
                    <div className='divTitleMessageBoardInformation'>
                        <img src="/icons/svgsDaNet/alert-triangle.svg"
                            style={{ filter: 'invert(87%) sepia(14%) saturate(7477%) hue-rotate(7deg) brightness(98%) contrast(102%)', width: '35px', marginRight: '10px' }}
                            alt="OrderService"
                        />
                        {t("AddGenerator")}
                    </div>
                }
                body={
                    <div>
                        <div>
                            {t("AdvanceWithGenerator")}
                        </div>
                        <br />
                        <div>
                            <b>{t("Note")}:</b> {t("AdvanceWithoutGenerator")}
                        </div>
                    </div>
                }
                footer={
                    <div className='divFooterAlertsOrderService'>
                        <M_Button
                            backgroundColor={'var(--color-red)'}
                            label={t("WhitoutGenerator")}
                            labelColor={'var(--color-white)'}
                            onClick={() => setOpenModalGenerator(false)}
                        />
                        <M_Button
                            backgroundColor={'var(--color-green)'}
                            label={t("ActivateGenerator")}
                            labelColor={'var(--color-white)'}
                            onClick={() => {
                                const hasGeneratorSubResourceNames = (
                                    optionsSubResource?.filter(sr => /generator/i.test(sr?.Name || '')).map(sr => sr.Name)
                                ) || ['Has Generator', 'HasGenerator', 'Generator']

                                setTransportResources(prevState => ({
                                    ...prevState,
                                    ["Has Generator"]: true,
                                    HasGenerator: true,
                                    Generator: true
                                }))
                                setTransportSubResources(prevState => ({
                                    ...(prevState || {}),
                                    ...hasGeneratorSubResourceNames.reduce((acc, name) => {
                                        acc[name] = true
                                        return acc
                                    }, {})
                                }))
                                setOpenModalGenerator(false)
                            }}

                        />
                    </div>
                }
            />

            {/* alerta de saida da ordem de serviço */}
            <M_MessageBoard
                open={modalReturn}
                onClose={() => setModalReturn(false)}
                warning
                title={
                    <div className='divTitleMessageBoardInformation'>

                        {t("titleCancelOrderService")}
                    </div>
                }
                body={
                    <div>
                        {t("labelInformationCancelOrderService")}
                    </div>
                }
                footer={
                    <div className='divFooterAlertsOrderService'>
                        <M_Button
                            backgroundColor={'var(--color-red)'}
                            label={t("Cancel")}
                            labelColor={'var(--color-white)'}
                            onClick={() => setModalReturn(false)}
                        />
                        <M_Button
                            backgroundColor={'var(--color-green)'}
                            label={t("Confirm")}
                            labelColor={'var(--color-white)'}
                            onClick={() => { ctx2.closeTab(id) }}
                        />
                    </div>
                }
            />
        </>
    )
}
